<template>
    <v-container fluid fill-height>
        <v-layout justify-center >
            <v-flex xs12>
                <!--<v-card flat>
                    <v-parallax height="150" src="/static/images/dancers-tile.jpg"></v-parallax>
                    <v-btn
                            color="red"
                            dark
                            small
                            absolute
                            bottom
                            right
                            fab
                            @click="$router.push('/user/dancer/create')"
                            style="z-index: 1;"
                    >
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-card>-->

                <v-btn v-if="$hasRole('admin') && needDancersBirthday"
                       :loading="unlocking"
                       :disabled="unlocking"
                       @click="unlockDancers"
                       slot="activator"
                       color="primary"
                       outline
                       v-t="'pages.dancers.unlock'"
                       block
                ></v-btn>

                <v-alert v-if="needDancersBirthday" icon="warning" type="warning" :value="true">
                    {{ $t('alerts.fix_dancers_birthday') }}
                </v-alert>

                <dancer-list show-broken actions></dancer-list>
            </v-flex>

            <v-tooltip left>
                <v-btn
                        color="red"
                        dark
                        fixed
                        bottom
                        right
                        fab
                        slot="activator"
                        @click="$router.push('/user/dancer/create')"
                >
                    <v-icon>add</v-icon>
                </v-btn>
                <span>Neuer Tänzer-/inn</span>
            </v-tooltip>
        </v-layout>
    </v-container>
</template>

<script>
    import DancerListComponent from '../../components/user/DancerList';
    import { mapState, mapMutations, mapActions } from 'vuex';

    export default {
        components: {
            'dancer-list': DancerListComponent
        },
        data() {
            return {
                unlocking: false
            };
        },
        computed: {
            needDancersBirthday: function () {
                let needs = false;
                this.dancers.items.forEach(dancer => {
                    if (dancer.needs_birthday) {
                        needs = true;
                        return false;
                    }
                });
                return needs;
            },
            ...mapState(['user', 'dancers'])
        },
        methods: {
            unlockDancers() {
                if (this.unlocking) {
                    return;
                }

                this.confirm({
                    headline: this.$t('pages.dancers.unlock') + '?',
                    text: this.$t('pages.dancers.unlock_description'),
                    callback: () => {
                        this.unlocking = true;

                        axios.put(`/api/v1/dancers/unlock/${this.user.id}`).then(response => {
                            this.loadDancers().then(() => {
                                this.unlocking = false;
                            });
                            this.loadStarterTemplates();
                        });
                    }
                });
            },
            ...mapMutations(['confirm']),
            ...mapActions(['loadDancers', 'loadStarterTemplates'])
        }
    }
</script>

<style scoped>
    /*v-parallax {
        width: 100%;
    }*/
</style>
